<template>
  <div v-if="!isDoublonProfession" :class="jel_getClassObject(content)">
    <label class="font-weight-normal m-0"> {{ content.titre }} </label>
    <Paragraphe :content="content" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Paragraphe from '@/components/base/Paragraphe.vue';

export default {
  name: 'InfoTitre',
  components: { Paragraphe },
  props: { content: { type: Object, required: true } },
  computed: {
    ...mapGetters({
      getIsDoublonProfession: 'profileComplet/getIsDoublonProfession',
    }),
    isDoublonProfession() {
      // industry' est dans la balise {{profileComplet.occupation.industry.text}}
      return this.content.richText.includes('industry') && this.getIsDoublonProfession;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep p {
  font-family: 'graphik_medium';
}
</style>
